import './App.css';
import { Navigate, Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import GuestHomePage from './pages/home/GuestHomePage';
import DefaultLayout from './layouts/DefaultLayout';
import MagazinePage from './pages/magazine/MagazinePage';
import MagazineDetailPage from './pages/magazine/MagazineDetailPage';
import FavMagazinePage from './pages/magazine/FavMagazinePage';
import NewsPage from './pages/new/NewsPage';
import NewsDetailPage from './pages/new/NewsDetailPage';
import NotFoundPage from './pages/NotFoundPage';
import PrivacyStatementPage from './pages/privacy-statement/PrivacyStatementPage';
import { useSelector } from 'react-redux';
import LikeMagazinePage from './pages/magazine/LikeMagazinePage';
import ProfilePage from './pages/Profile/ProfilePage';
import FashionPage from './pages/fashion/FashionPage';
import FashionDetailPage from './pages/fashion/FashionDetailPage';
import GalleryDetailPage from './pages/fashion/GalleryDetailPage';
import EducationPage from './pages/education/EducationPage';
import TechnologyDetailPage from './pages/education/TechnologyDetailPage';
import OnlineClassListPage from './pages/education/OnlineClassListPage';
import OnlineClassDetailPage from './pages/education/OnlineClassDetailPage';
import ProductPage from './pages/product/ProductPage';
import FunFactsDetailPage from './pages/education/FunFactsDetailPage';
import EductionDetailPage from './pages/new/EductionDetailPage';
import LikeCoursePage from './pages/education/LikeCoursePage';
import PurchasedCoursePage from './pages/education/PurchasedCoursePage';
import OnlineClassMemberPage from './pages/education/OnlineClassMemberPage';

import ProductDetailPage from './pages/product/ProductDetailPage';
import CartPage from './pages/cart/CartPage';
import CheckoutPage from './pages/checkout/CheckoutPage';
import OrderConfirmationPage from './pages/checkout/OrderConfirmationPage';
import MyOrdersPage from './pages/orders/MyOrdersPage';
import OrderDetailPage from './pages/orders/OrderDetailPage';
import PurchaseHistoryPage from './pages/orders/PurchaseHistoryPage';
import AddressListPage from './pages/address/AddressListPage';
import AddAddressPage from './pages/address/AddAddressPage';
import EditAddressPage from './pages/address/EditAddressPage';
import MyActivitiesPage from './pages/Profile/MyActivitiesPage';
import EventDetailPage from './pages/events/EventDetailPage';
import ShareFormPage from './pages/events/ShareFormPage';
import ProductKnowledgePage from './pages/product/ProductKnowledgePage';
import ProductKnowledgeDetailPage from './pages/product/ProductKnowledgeDetailPage';
// import EducatePage from './pages/EducatePage';

function App() {
  const user = useSelector((state) => state.authReducer);
  let token = user && user?.token ? user?.token : null;
  const isRegistered = Boolean(token && user?.user?.completedTS);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<DefaultLayout />}>
          <Route path='/' element={<GuestHomePage />} />
          <Route path='/privacy_statement' element={<PrivacyStatementPage />} />
          <Route path='/events/:id' element={<EventDetailPage />} />
          <Route path='/shareform' element={<ShareFormPage />} />
          {/* <Route path="*" element={<NotFoundPage />} /> */}
        </Route>

        <Route element={!isRegistered ? <Navigate to={`/`} replace /> : <DefaultLayout />}>
          <Route path='/fav-magazine' element={<FavMagazinePage />} />
          <Route path='/like-magazine' element={<LikeMagazinePage />} />
          <Route path='/profiles' element={<ProfilePage />} />
          <Route path='/my-activities' element={<MyActivitiesPage />} />
          <Route path='/like-course' element={<LikeCoursePage />} />
          <Route path='/purchased-course' element={<PurchasedCoursePage />} />
          <Route path='/news' element={<NewsPage />} />
          <Route path='/news/:code' element={<NewsDetailPage />} />
          <Route path='/fashion' element={<FashionPage />} />
          <Route path='/fashion/detail' element={<FashionDetailPage />} />
          <Route path='/gallery/detail' element={<GalleryDetailPage />} />
          <Route path='/fashion/:id' element={<FashionDetailPage />} />
          <Route path='/education' element={<EducationPage />} />
          <Route path='/technical/:code' element={<EductionDetailPage />} />
          <Route path='/technical/detail/:categoryID' element={<TechnologyDetailPage />} />
          <Route path='/online-class' element={<OnlineClassListPage />} />
          <Route path='/online-class/:id' element={<OnlineClassDetailPage />} />
          <Route path='/online-class-member/:id' element={<OnlineClassMemberPage />} />
          <Route path='/product' element={<ProductPage />} />
          <Route path='/product/:id' element={<ProductDetailPage />} />
          <Route path='/product-knowledge' element={<ProductKnowledgePage />} />
          <Route path='/product-knowledge/:id' element={<ProductKnowledgeDetailPage />} />
          <Route path='/cart' element={<CartPage />} />
          <Route path='/checkout' element={<CheckoutPage />} />
          <Route path='/order-confirmation' element={<OrderConfirmationPage />} />
          <Route path='/my-orders' element={<MyOrdersPage />} />
          <Route path='/my-orders/:orderId' element={<OrderDetailPage />} />
          <Route path='/purchase-history' element={<PurchaseHistoryPage />} />
          <Route path='/address-list' element={<AddressListPage />} />
          <Route path='/add-address' element={<AddAddressPage />} />
          <Route path='/edit-address/:id' element={<EditAddressPage />} />
          <Route path='/about-us' element={<HomePage />} />
          <Route path='/magazine' element={<MagazinePage />} />
          <Route path='/magazine/:id' element={<MagazineDetailPage />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
